import { atom, selector, selectorFamily } from 'recoil'

export const resultsState = atom({
  key: 'smtpplusListResultsState',
  default: {
    items: [],
    totalItems: 0,
    searchParams: {}
  }
})

export const resultsStateSearchParams = selector({
  key: 'smtpplusListResultsStateSearchParams',
  get: ({ get }) => get(resultsState).searchParams,
  set: ({ set }, searchParams) =>
    set(resultsState, prev => ({
      ...prev,
      searchParams
    }))
})

export const resultsStateEmptyState = selector({
  key: 'smtpplusResultsStateEmptyState',
  get: ({ get }) => {
    const { items, searchParams } = get(resultsState)
    const searchHasParams = evalSearchHasParams(searchParams)
    return !items.length && !searchHasParams
  }
})

const evalSearchHasParams = (searchParams) => {
  if (!searchParams || !Object.keys(searchParams).length) {
    return false
  }
  return Object.entries(searchParams).reduce((r, [key, val]) => {
    if (['pageNumber', 'pageSize', 'orderBy', 'orderDesc'].includes(key)) {
      return r
    }

    if (key === 'filterByField' && val === 'LastUpdated') {
      return r
    }

    if (val) {
      return true
    }

    return r || false
  }, false)
}

export const resultsStateHasSearchParams = selector({
  key: 'smtpplusResultsStateHasSearchParams',
  get: ({ get }) => {
    const { searchParams } = get(resultsState)
    return evalSearchHasParams(searchParams)
  }
})

export const singleResultSelector = selectorFamily({
  key: 'smtpplusListSingleResultSelector',
  get: (idMessage) => ({ get }) => {
    const results = get(resultsState)
    return results.items.find(item => item.Id === idMessage)
  }
})

export const selectionState = atom({
  key: 'smtpplusListSelectionState',
  default: []
})

export const allCheckedSelector = selector({
  key: 'smtpplusListAllCheckedSelector',
  get: ({ get }) => {
    const selection = get(selectionState)
    const searchResult = get(resultsState)
    return (selection.length > 0) && (selection.length === searchResult.items.length)
  },
  set: ({ get, set }, checked) => {
    const searchResult = get(resultsState)
    if (checked) {

      const selectedIds = get(selectionState)
      set(selectionState, Array.from(new Set([...selectedIds, ...searchResult.items.map(item => item.Id)])))
    } else {
      set(selectionState, [])
    }
  }
})

export const singleCheckedSelector = selectorFamily({
  key: 'smtpplusListSingleCheckedSelector',
  get: (idMessage) => ({ get }) => {
    const selection = get(selectionState)
    return selection.includes(idMessage)
  },
  set: (idMessage) => ({ get, set }, checked) => {
    if (checked) {
      set(selectionState, (prev) => ([...prev, idMessage]))
    } else {
      set(selectionState, (prev) => ([...prev.filter(id => id !== idMessage)]))
    }
  }
})

export const fixedContextMenuVisibleSelector = selector({
  key: 'smtpplusListFixedContextMenuVisibleSelector',
  get: ({ get }) => {
    const selection = get(selectionState)
    return selection.length > 0
  }
})
